import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LoadingScreen = ({ onComplete }) => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Check if already loaded in this session
    const hasLoaded = sessionStorage.getItem('hasLoaded');
    if (hasLoaded) {
      setShowLoader(false);
      onComplete?.();
      return;
    }

    // Show loader for 1.5 seconds
    const timer = setTimeout(() => {
      setShowLoader(false);
      sessionStorage.setItem('hasLoaded', 'true');
      onComplete?.();
    }, 1500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {showLoader && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[10000] bg-[#0D0D0D] flex items-center justify-center"
          data-testid="loading-screen"
        >
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ 
              duration: 0.5,
              delay: 0.2,
              exit: { duration: 0.3 }
            }}
            className="font-serif text-4xl sm:text-5xl md:text-6xl text-[#C9A84C] tracking-wide"
          >
            It's Lahore
          </motion.h1>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
